// extracted by mini-css-extract-plugin
module.exports = {"signup":"Security_signup__1wgtI","container":"Security_container__3BK22","signupButton":"Security_signupButton__3xJ6d"};